import { render, staticRenderFns } from "./CatalogSection.vue?vue&type=template&id=912947a4"
import script from "./CatalogSection.vue?vue&type=script&lang=js"
export * from "./CatalogSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports